import {ParticipantsFiltersAvailability} from "@share/participants-table/types/ParticipantsFiltersAvailability";
import {ParticipantsFilters} from "@share/participants-table/enums/ParticipantsFilters";

export const filtersAvailabilityDefaultValue = (availableFilters: ParticipantsFilters[] = []): ParticipantsFiltersAvailability => {
    let result: ParticipantsFiltersAvailability = {} as any;

    Object.values(ParticipantsFilters).forEach(filterName => {
        result[filterName] = availableFilters.length === 0 || availableFilters.indexOf(filterName) >= 0;
    });

    return result;
}